export default __webpack_public_path__ + "images/linearProgressBarLogo.1c67d3c7ec1bddf33accff1d4cfd5d61.svg";